import { FirstAlignArea } from './first-align-area';
import {
    RectHorizontalAlignType,
    RectVerticalAlignType,
} from '@src/slide/infrastructure/module/independent/graphic/rect/rect';

// 标题模版
export class VTitleTemplate {
    public horAlignType: RectHorizontalAlignType = RectHorizontalAlignType.Same;
    public verAlignType: RectVerticalAlignType = RectVerticalAlignType.Same;

    public constructor(public height: number, public templateArea: FirstAlignArea) {
    }
}
